import { render } from "./ArrowUpCircleIcon.vue?vue&type=template&id=25f06fac"
import script from "./ArrowUpCircleIcon.vue?vue&type=script&lang=js"
export * from "./ArrowUpCircleIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__